const addons = [
  {
    price: '+$80',
    title: 'Agrega un familiar mas',
    tag: 'Familiar adicional',
    description:
      'Suma un integrante adicional de tu familia directa al plan. Cada familiar adicional tiene su propio periodo de carencia de 90 dias desde su registro.',
    cta: 'Agregar familiar',
    wa: 'https://wa.me/526675680042?text=Hola%2C%20quiero%20agregar%20un%20familiar%20adicional%20a%20mi%20plan%20Coverly',
  },
  {
    price: '+$110',
    title: 'Incluye cremacion en tu plan',
    tag: 'Cremacion',
    description:
      'Agrega la opcion de cremacion con urna clasica o ecologica a tu plan. Si al momento del servicio la familia prefiere inhumacion, aplica lo establecido en el contrato.',
    cta: 'Agregar cremacion',
    wa: 'https://wa.me/526675680042?text=Hola%2C%20quiero%20agregar%20la%20opcion%20de%20cremacion%20a%20mi%20plan%20Coverly',
  },
];

export default function PricingAddons() {
  return (
    <section className="bg-[#EEEDFE] py-10 md:py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-6 md:mb-12">
          <h2 className="font-title text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-[#0A0A0A] mb-3">
            Personaliza tu plan
          </h2>
          <p className="text-[#0A0A0A]/55 text-xs md:text-base">
            Complementos disponibles conforme al plan contratado.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {addons.map((addon) => (
            <div key={addon.tag} className="bg-white rounded-2xl p-5 md:p-8 flex flex-col gap-3 md:gap-4" style={{ boxShadow: '0 2px 20px rgba(83,74,183,0.07)' }}>
              <span className="inline-block self-start bg-[#EEEDFE] text-[#534AB7] text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap">{addon.tag}</span>
              <div className="flex items-end gap-1">
                <span className="font-title text-[#534AB7] text-3xl md:text-5xl font-bold">{addon.price}</span>
                <span className="text-[#534AB7]/60 text-sm mb-2">/mes</span>
              </div>
              <h3 className="font-title text-[#0A0A0A] text-base md:text-xl font-bold">{addon.title}</h3>
              <p className="text-[#0A0A0A]/60 text-sm leading-relaxed flex-1">{addon.description}</p>
              <a href={addon.wa} target="_blank" rel="nofollow noreferrer" className="mt-2 w-full border-2 border-[#534AB7] text-[#534AB7] hover:bg-[#534AB7] hover:text-white font-semibold py-3 rounded-full text-center text-sm transition-all duration-300 whitespace-nowrap cursor-pointer block">{addon.cta}</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
